import type {User} from '../types';
import {useGetUsersQuery} from '../usersApi';

/**
 * Hook to look up user by userId, if available/existing.
 */
export const useUserById = (userId: string | undefined): User | undefined => {
  const {user} = useGetUsersQuery(undefined, {
    selectFromResult: ({data}) => ({
      user: data?.find(user => user.id === userId),
    }),
  });

  return user;
};
